import type { UserState } from './interfaces';

export const initialState: UserState = {
  loading: false,
  data: null,
} satisfies UserState as UserState;
